import { useMemo, useState, useEffect } from "react"

import { ILaundry, ILaundryBranch } from "types/laundry"
import { IDropdownItem } from "components/UI/atoms/Dropdown/DropdownTypes"
import { useAppContext } from "providers/AppProvider/AppProvider"

const useCompanyBranches = () => {
  const { laundry, branches, laundryBranchesDataLoading, selectedBranches, updateSelectedBranches,  isAdmin } = useAppContext()

  const [selectAll, setSelectAll] = useState(false)
  const [singleLaundry, setSingleLaundry] = useState<ILaundry | null>(null)
  const [branchOptions, setBranchOptions] = useState<IDropdownItem[]>([])
  const generateOptions = (branches: ILaundryBranch[]) => {
    const options: IDropdownItem[] = branches.map((branch)=>({
      id: branch.id,
      label: branch.address,
      value: branch.address,
      leftImg: branch.logoUrl || "",
      name: branch.name,
      withCheckbox: true
    })) || []
    setBranchOptions(options)
  }

  useEffect(()=>{
    if(!isAdmin && laundry) {
      setSingleLaundry(laundry)
    }
  },[laundry])

  useEffect(()=>{
    if(branches?.data !== undefined) {
      generateOptions(branches?.data)
    }
  },[branches])


  return useMemo(()=>({
    isAdmin,
    singleLaundry,
    selectedBranches,
    updateSelectedBranches,
    laundryBranchesDataLoading,
    branchOptions,
    selectAll,
    setSelectAll,
  }),[selectedBranches, branchOptions, singleLaundry, laundryBranchesDataLoading, selectAll])
}

export default useCompanyBranches